(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_custom-social-carousel-card"] && !Shopify.designMode) return;
  try {
    // CSS can't pause a video, so prefers-reduced-motion is honored here instead.
  (() => {
    const CARD = '.custom-social-carousel-card';
    const VIDEO = '.custom-social-carousel-card__video';
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const relabel = (button, key) => {
      if (button && button.dataset[key]) button.setAttribute('aria-label', button.dataset[key]);
    };

    // Repainted from the video's own state, so the buttons stay honest when the browser
    // pauses or mutes on its own rather than through a click.
    const paint = (video) => {
      const card = video.closest(CARD);
      if (!card) return;
      card.dataset.playing = video.paused ? 'false' : 'true';
      card.dataset.muted = video.muted ? 'true' : 'false';
      relabel(card.querySelector('[data-social-video-toggle]'), video.paused ? 'labelPlay' : 'labelPause');
      relabel(card.querySelector('[data-social-video-sound]'), video.muted ? 'labelUnmute' : 'labelMute');
      relabel(card.querySelector('[data-social-video-play]'), video.paused ? 'labelPlay' : 'labelPause');
    };

    /** @param {HTMLVideoElement} video - A product card's video: no autoplay, it plays on a tap. */
    const onTap = (video) => video.dataset.playOnTap !== undefined;

    // Retry muted only when sound was refused (lapsed tap activation), never after a pause.
    /** @param {HTMLVideoElement} video */
    const play = (video) =>
      video
        .play()
        .catch((error) => {
          if (error?.name !== 'NotAllowedError' || video.muted) return;
          video.muted = true;
          return video.play();
        })
        .catch(() => {});

    // One voice at a time: the other tap videos pause, autoplaying ones go muted.
    /** @param {HTMLVideoElement} video */
    const playAloud = (video) => {
      document.querySelectorAll(VIDEO).forEach((other) => {
        if (other === video || !(other instanceof HTMLVideoElement)) return;
        if (onTap(other)) other.pause();
        else other.muted = true;
      });
      video.muted = false;
      if (video.dataset.choosing !== undefined) video.dataset.choosing = 'play';
      else play(video);
    };

    /** @param {HTMLVideoElement} video */
    const start = (video) => {
      if (video.dataset.choosing !== undefined) return;
      if (onTap(video)) {
        paint(video);
        return;
      }
      if (reduceMotion.matches) {
        video.pause();
      } else {
        video.play().catch(() => {});
      }
      paint(video);
    };

    /** @param {HTMLVideoElement} video */
    const reveal = (video) => {
      video.querySelectorAll('source[data-src]').forEach((source) => {
        source.setAttribute('src', source.getAttribute('data-src') || '');
        source.removeAttribute('data-src');
      });
      video.dataset.revealed = 'true';
      // Four 720p cards need 15 Mbps between them; the 480p file stretched 1.24x needs 5.
      return import('@theme/custom.video-rendition')
        .then(({ preferRendition }) => preferRendition(video, undefined, undefined, {
          upscale: 1.5,
          timeout: 4000,
        }))
        .catch(() => {})
        .then(() => {
          const asked = video.dataset.choosing === 'play';
          delete video.dataset.choosing;
          if (!video.isConnected) return;
          video.load();
          if (asked) play(video);
          else start(video);
        });
    };

    // The first-frame deadline starts after rendition selection, which has its own timeout.
    const FIRST_FRAME_WAIT = 4000;
    /** @type {HTMLVideoElement[]} */
    const queue = [];
    let starting = false;
    const startNext = () => {
      if (starting) return;
      let video = queue.shift();
      while (video && !video.isConnected) video = queue.shift();
      if (!video) return;
      starting = true;
      let timer = 0;
      let finished = false;
      const next = () => {
        if (finished) return;
        finished = true;
        clearTimeout(timer);
        video.removeEventListener('loadeddata', next);
        video.removeEventListener('playing', next);
        video.removeEventListener('error', next);
        starting = false;
        startNext();
      };
      video.addEventListener('loadeddata', next, { once: true });
      video.addEventListener('playing', next, { once: true });
      video.addEventListener('error', next, { once: true });
      reveal(video).then(() => {
        if (finished) return;
        if (!video.isConnected || reduceMotion.matches) next();
        else timer = setTimeout(next, FIRST_FRAME_WAIT);
      });
    };

    const revealer = new IntersectionObserver(
      (entries) => {
        entries.forEach(({ isIntersecting, target }) => {
          if (!isIntersecting || !(target instanceof HTMLVideoElement)) return;
          revealer.unobserve(target);
          if (target.dataset.revealed || target.dataset.choosing !== undefined) return;
          target.dataset.choosing = '';
          // A tap video loads nothing until played, so it need not wait its turn.
          if (onTap(target)) {
            reveal(target);
            return;
          }
          queue.push(target);
          startNext();
        });
      },
      { rootMargin: '0px 0px 200px 0px' }
    );

    const sync = () => {
      document.querySelectorAll(VIDEO).forEach((video) => {
        if (!(video instanceof HTMLVideoElement)) return;
        if (video.dataset.revealed) {
          start(video);
          return;
        }
        // The markup ships as playing; until the sources load, the button must offer Play.
        paint(video);
        revealer.observe(video);
      });
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest(
        '[data-social-video-toggle], [data-social-video-sound], [data-social-video-play]'
      );
      if (!button) return;
      // The link covers the card and the carousel listens for drags, so neither may see this.
      event.preventDefault();
      event.stopPropagation();

      const video = button.closest(CARD)?.querySelector(VIDEO);
      if (!video) return;

      if (button.hasAttribute('data-social-video-sound')) {
        video.muted = !video.muted;
      } else if (button.hasAttribute('data-social-video-play') && video.paused) {
        playAloud(video);
      } else if (video.dataset.choosing !== undefined) {
        // Playing now would start the 1080p file that load() is about to replace; play after it.
        video.dataset.choosing = 'play';
      } else if (video.paused) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
      paint(video);
    });

    // Media events do not bubble, so they are caught on the way down.
    ['play', 'pause', 'volumechange', 'loadeddata', 'playing'].forEach((type) => {
      document.addEventListener(
        type,
        (event) => {
          const video = event.target;
          if (!(video instanceof HTMLVideoElement) || !video.matches(VIDEO)) return;
          if (type === 'loadeddata' || type === 'playing') video.dataset.ready = 'true';
          paint(video);
        },
        true
      );
    });

    sync();
    reduceMotion.addEventListener('change', sync);
    document.addEventListener('shopify:section:load', sync);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-product-affirm"] && !Shopify.designMode) return;
  try {
    const AFFIRM_SRC = 'https://cdn1.affirm.com/js/v2/affirm.js';

  class CustomProductAffirm extends HTMLElement {
    /** @type {MutationObserver | null} */
    #observer = null;

    /** @type {string | null} */
    #lastAmount = null;

    connectedCallback() {
      this.#loadAffirm();
      this.closest('.shopify-section')?.addEventListener('variant:update', this.#onVariantUpdate);

      const promo = this.querySelector('.affirm-as-low-as');
      if (!promo) return;

      this.#lastAmount = promo.getAttribute('data-amount');
      this.#observer = new MutationObserver(() => this.#maybeRefresh());
      this.#observer.observe(this, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['data-amount'],
      });

      /* affirm.js fills elements once at load; a re-rendered block connects empty. */
      if (promo.childNodes.length === 0) this.#refresh();
    }

    disconnectedCallback() {
      this.closest('.shopify-section')?.removeEventListener('variant:update', this.#onVariantUpdate);
      this.#observer?.disconnect();
      this.#observer = null;
    }

    /* Twin of the loader in snippets/custom.cart-affirm.liquid; whichever element connects
       first loads the script, the other finds it already in <head>. */
    #loadAffirm() {
      if (document.querySelector(`script[src="${AFFIRM_SRC}"]`)) return;

      window._affirm_config = {
        public_api_key: this.dataset.publicApiKey,
        script: AFFIRM_SRC,
      };
      const script = document.createElement('script');
      script.src = AFFIRM_SRC;
      script.async = true;
      document.head.append(script);
    }

    /** @param {CustomEvent} event */
    #onVariantUpdate = (event) => {
      const { html, productId } = event.detail?.data ?? {};
      if (productId && productId !== this.dataset.productId) return;

      const next = html?.querySelector(
        `custom-product-affirm[data-block-id="${this.dataset.blockId}"] .affirm-as-low-as`
      );
      const promo = this.querySelector('.affirm-as-low-as');
      if (!next || !promo) return;

      promo.setAttribute('data-amount', next.getAttribute('data-amount') ?? '');
    };

    /* Converges rather than loops: affirm.ui.refresh() re-fills the promo element without
       touching data-amount, so its own mutations fail both conditions below. */
    #maybeRefresh() {
      const promo = this.querySelector('.affirm-as-low-as');
      if (!promo) return;

      const amount = promo.getAttribute('data-amount');
      const stripped = promo.childNodes.length === 0;
      if (amount === this.#lastAmount && !stripped) return;

      this.#lastAmount = amount;
      this.#refresh();
    }

    /* Before affirm.js loads there is nothing to call; its init pass fills every
       .affirm-as-low-as already in the document, so an early mutation needs no retry. */
    #refresh() {
      const ui = window.affirm?.ui;
      if (!ui?.refresh) return;
      if (typeof ui.ready === 'function') {
        ui.ready(() => ui.refresh());
      } else {
        ui.refresh();
      }
    }
  }

  if (!customElements.get('custom-product-affirm')) {
    customElements.define('custom-product-affirm', CustomProductAffirm);
  }
  } catch(e) { console.error(e); }
})();

})();
